import React, { useState } from "react";
import { toast } from "sonner";
import { Pencil, ImageOff, Trash2, RotateCcw, Check, X } from "lucide-react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "./ui/alert-dialog";

const btn = "inline-flex items-center gap-1 rounded-lg px-2.5 h-8 text-xs font-semibold border transition-colors";

const run = async (fn, ok, after) => {
  try { await fn(); toast.success(ok); after?.(); }
  catch (e) { toast.error(e?.response?.data?.detail || "Operazione non riuscita"); }
};

export const AdminPlayerActions = ({ name, hasPhoto, hidden, onChanged, slug }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(name);
  const id = slug || name.toLowerCase().replace(/\s+/g, "-");

  if (editing) {
    return (
      <div className="flex gap-2 items-center">
        <Input value={value} onChange={(e) => setValue(e.target.value)} data-testid={`admin-rename-input-${id}`} className="bg-[#0b1420] border-[#1e2c4a] text-slate-100 h-8" />
        <button data-testid={`admin-rename-save-${id}`} className={`${btn} bg-[#ccff00] text-[#090d16] border-[#ccff00]`}
          onClick={() => run(() => api.adminRenamePlayer(name, value), `Rinominato in ${value}`, () => { setEditing(false); onChanged?.(value.trim()); })}>
          <Check className="w-3.5 h-3.5" />
        </button>
        <button data-testid={`admin-rename-cancel-${id}`} className={`${btn} border-slate-700 text-slate-300`} onClick={() => { setEditing(false); setValue(name); }}>
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid={`admin-player-actions-${id}`}>
      <button data-testid={`admin-rename-${id}`} onClick={() => setEditing(true)} className={`${btn} border-[#1e2c4a] text-[#ccff00] hover:bg-[#1e2c4a]`}>
        <Pencil className="w-3.5 h-3.5" /> Rinomina
      </button>
      {hasPhoto && (
        <button data-testid={`admin-remove-photo-${id}`} onClick={() => run(() => api.adminRemovePhoto(name), "Foto rimossa", () => onChanged?.(name))}
          className={`${btn} border-[#1e2c4a] text-slate-300 hover:bg-[#1e2c4a]`}>
          <ImageOff className="w-3.5 h-3.5" /> Togli foto
        </button>
      )}
      {hidden ? (
        <button data-testid={`admin-restore-player-${id}`} onClick={() => run(() => api.adminRestorePlayer(name), "Scheda ripristinata", () => onChanged?.(name))}
          className={`${btn} border-[#1e2c4a] text-slate-300 hover:bg-[#1e2c4a]`}>
          <RotateCcw className="w-3.5 h-3.5" /> Ripristina in classifica
        </button>
      ) : (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button data-testid={`admin-delete-player-${id}`} className={`${btn} border-[#ff4d4d]/40 text-[#ff4d4d] hover:bg-[#ff4d4d]/10`}>
              <Trash2 className="w-3.5 h-3.5" /> Cancella scheda
            </button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-[#121b2d] border-[#1e2c4a] text-slate-100">
            <AlertDialogHeader>
              <AlertDialogTitle>Cancellare la scheda di {name}?</AlertDialogTitle>
              <AlertDialogDescription className="text-slate-400">
                Verranno tolti foto, voti e pagelle ricevuti, e il giocatore sparirà da classifiche, coppie e MVP. I risultati restano validi per gli altri giocatori. L'account (se c'è) non viene eliminato: se continua a giocare resterà nascosto finché non lo ripristini.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="bg-transparent border-slate-700 text-slate-200 hover:bg-slate-800 hover:text-white">Annulla</AlertDialogCancel>
              <AlertDialogAction data-testid={`admin-delete-player-${id}-confirm`} className="bg-[#ff4d4d] hover:bg-[#e04343] text-white"
                onClick={() => run(() => api.adminDeletePlayerCard(name), "Scheda cancellata", () => onChanged?.(null))}>
                Cancella
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
};
